import { render, staticRenderFns } from "./vueTransfer.vue?vue&type=template&id=6066f1ab&scoped=true"
import script from "./vueTransfer.vue?vue&type=script&lang=js"
export * from "./vueTransfer.vue?vue&type=script&lang=js"
import style0 from "./vueTransfer.vue?vue&type=style&index=0&id=6066f1ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6066f1ab",
  null
  
)

export default component.exports